/* 商品一覧のページ送りを、スクロールでの自動読み込みに変える。
   コレクションページと検索結果ページの両方で動く。

   方針

   ・ページ送りのリンクは HTML に残したまま、画面からだけ外す。
     検索エンジンは画面をスクロールしない。リンクを消すと
     2ページ目以降の商品へたどる道が無くなるため、残す必要がある。

   ・代わりに「もっと見る」を出す。これは次ページへの本物のリンクで、
     JavaScript が動かない環境ではそのまま次ページへ移動できる。

   ・商品ページから一覧へ戻ったときは、読み込み済みのページ数を復元して
     から、見ていた商品の位置へ移動する。ブラウザ標準の位置復元は
     読み込み直後の DOM（＝1ページ目だけ）に対して働くので、
     自動読み込みと組み合わせると効かない。ここで肩代わりする。 */
(function () {
  'use strict';

  var STATE_KEY = 'ts-list-state';
  var CONTAINER = '#ProductGridContainer';
  var GRID = '#product-grid';
  var PAGER = '.pagination-wrapper';
  var STATE_TTL = 30 * 60 * 1000; // 30分より古い記録は使わない

  var current = null;

  /* ---------- 小さな道具 ---------- */

  // 「次のページ」のURLを、いま何ページ目かを見て決める。
  // Dawn は前へ・次への両方に同じクラスを付けるので、
  // クラス名ではなく page= の値で判断する。
  function nextUrl(pager) {
    if (!pager) return null;
    var cur = parseInt(pager.getAttribute('data-page'), 10) || 1;
    var want = String(cur + 1);
    var links = pager.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      try {
        var u = new URL(links[i].href, location.origin);
        if (u.searchParams.get('page') === want) return u.href;
      } catch (e) {}
    }
    return null;
  }

  // 商品を並べている ul を返す。
  // コレクションでは #product-grid がその ul 自身だが、
  // 検索結果では #product-grid は外側の div で、ul はその中にある。
  // div のまま扱うと、ページ送りや読み込み中の幕まで一緒に足してしまう。
  function findGrid(root) {
    var el = root.querySelector(GRID);
    if (el && el.tagName !== 'UL') el = el.querySelector('ul.grid') || el;
    return el;
  }

  // 記録の照合に使う、page= を除いた今のURL
  function baseUrl() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('page');
      return u.pathname + u.search;
    } catch (e) {
      return location.pathname;
    }
  }

  // /products/xxxx から xxxx を取り出す。
  // あとで属性セレクタに入れるので、英数字とハイフンだけに限る。
  function handleOf(href) {
    var m = /\/products\/([A-Za-z0-9_-]+)/.exec(href || '');
    return m ? m[1] : null;
  }

  function readState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null');
      if (!s || Date.now() - s.t > STATE_TTL) return null;
      return s;
    } catch (e) {
      return null;
    }
  }

  function clearState() {
    try { sessionStorage.removeItem(STATE_KEY); } catch (e) {}
  }

  // 戻ってきたのかどうか。ブラウザの戻る操作か、
  // 同じストアの商品ページから来た場合だけ位置を復元する。
  function cameBack() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') return true;
    } catch (e) {}
    try {
      var r = new URL(document.referrer);
      if (r.origin === location.origin && r.pathname.indexOf('/products/') !== -1) return true;
    } catch (e) {}
    return false;
  }

  /* ---------- 本体 ---------- */

  function List(container) {
    this.container = container;
    this.grid = findGrid(container);
    this.pager = container.querySelector(PAGER);
    this.busy = false;
    this.restoring = false;
    this.pages = 1;
    this.io = null;
    this.sentinel = null;
  }

  List.prototype.usable = function () {
    // ページ送りが無い＝1ページに収まっている。何もしない。
    return !!(this.grid && this.pager && nextUrl(this.pager));
  };

  List.prototype.setup = function () {
    // ブラウザ標準の位置復元は読み込み直後の DOM（1ページ目だけ）に対して働くため、
    // 自動読み込みと組み合わせると位置がずれる。ここで止めて、restore で肩代わりする。
    // 1ページに収まる一覧（usable でないもの）では止めない。標準の復元に任せる。
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    this.grid.setAttribute('data-ts-infinite', 'on');
    this.decorate();
    this.watch();
    this.rememberClicks();
  };

  // ページ送りの見た目を差し替える。
  // 数字のリンクは消さずに隠すだけ（検索エンジン向けに残す）。
  List.prototype.decorate = function () {
    if (!this.pager) return;
    this.pager.classList.add('ts-pager--auto');

    var url = nextUrl(this.pager);
    var btn = this.pager.querySelector('.ts-more');

    if (!url) {
      if (btn) btn.remove();
      return;
    }
    if (!btn) {
      var self = this;
      btn = document.createElement('a');
      btn.className = 'ts-more';
      btn.textContent = this.pager.getAttribute('data-more-label') || 'もっと見る';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.next();
      });
      this.pager.insertAdjacentElement('afterbegin', btn);
    }
    btn.setAttribute('href', url);
  };

  // 一覧の下に置いた目印が画面に入ったら次を読む。
  // 600px 手前で動かして、待たされる感じを減らす。
  List.prototype.watch = function () {
    if (!('IntersectionObserver' in window)) return;
    var self = this;
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'ts-infinite-sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');
    this.grid.insertAdjacentElement('afterend', this.sentinel);

    this.io = new IntersectionObserver(function (entries) {
      // 位置の復元中は restore が順に読むので、ここからは読まない
      if (entries[0].isIntersecting && !self.restoring) self.next();
    }, { rootMargin: '600px 0px' });
    this.io.observe(this.sentinel);
  };

  // 目印がまだ範囲内かを判定し直す。
  // IntersectionObserver は「入った・出た」の変化でしか知らせてこない。
  // ページの最下部で読み込みが終わると、ブラウザのスクロール位置の保持
  // （scroll anchoring）で画面も一緒に下がり、目印が範囲内に残ったままになる。
  // そのままだと次の知らせが来ずに止まるので、監視をかけ直して今の状態を受け取る。
  List.prototype.recheck = function () {
    if (!this.io || !this.sentinel || this.restoring) return;
    this.io.unobserve(this.sentinel);
    this.io.observe(this.sentinel);
  };

  List.prototype.stop = function () {
    if (this.io) { this.io.disconnect(); this.io = null; }
  };

  List.prototype.next = function () {
    var self = this;
    if (self.busy || !self.pager) return Promise.resolve(false);
    var url = nextUrl(self.pager);
    if (!url) { self.stop(); return Promise.resolve(false); }

    self.busy = true;
    self.pager.classList.add('is-loading');

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = findGrid(doc);
        var newPager = doc.querySelector(PAGER);

        if (newGrid && newGrid.children.length) {
          var frag = document.createDocumentFragment();
          while (newGrid.children.length) {
            var li = newGrid.children[0];
            // 表示アニメーションは読み込み時にしか仕掛けられないため、
            // 後から足した分は外しておく。付けたままだと隠れたままになる。
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            li.removeAttribute('data-cascade');
            li.removeAttribute('style');
            frag.appendChild(li);
          }
          self.grid.appendChild(frag);
        }

        if (newPager) {
          self.pager.outerHTML = newPager.outerHTML;
          self.pager = self.container.querySelector(PAGER);
          self.decorate();
        } else {
          // 最終ページ。ページ送りごと消える。
          self.pager.remove();
          self.pager = null;
          self.stop();
        }
        self.pages += 1;
        return true;
      })
      .catch(function () {
        // 読み込めなかった場合は自動読み込みをやめ、
        // 元のページ送りを見える状態に戻す。手で進めるようにする。
        if (self.pager) self.pager.classList.remove('ts-pager--auto');
        self.stop();
        return false;
      })
      .then(function (ok) {
        self.busy = false;
        if (self.pager) self.pager.classList.remove('is-loading');
        if (ok) self.recheck();
        return ok;
      });
  };

  // 商品ページへ移る直前に、どこまで読んでいたかを控える
  List.prototype.rememberClicks = function () {
    var self = this;
    this.grid.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      try {
        sessionStorage.setItem(STATE_KEY, JSON.stringify({
          url: baseUrl(),
          pages: self.pages,
          handle: handleOf(a.getAttribute('href')),
          y: window.scrollY || 0,
          t: Date.now()
        }));
      } catch (err) {}
    }, true);
  };

  // 控えておいたページ数まで読み直してから、見ていた商品まで動かす
  List.prototype.restore = function (state) {
    var self = this;
    var remaining = Math.max(0, (state.pages || 1) - 1);
    self.restoring = true;

    function step() {
      if (remaining <= 0) return Promise.resolve();
      remaining -= 1;
      return self.next().then(function (ok) {
        return ok ? step() : null;
      });
    }

    return step().then(function () {
      self.scrollTo(state);
      clearState();
      self.restoring = false;
      self.recheck();
    });
  };

  // 見ていた商品を画面の中央に出す。見つからなければ控えておいた位置へ
  List.prototype.scrollTo = function (state) {
    var target = null;
    if (state.handle) {
      target = this.grid.querySelector('a[href*="/products/' + state.handle + '"]');
    }
    if (target) {
      var li = target.closest('li') || target;
      li.scrollIntoView({ block: 'center' });
    } else if (typeof state.y === 'number') {
      window.scrollTo(0, state.y);
    }
  };

  /* ---------- 立ち上げ ---------- */

  function start(container) {
    var grid = findGrid(container);
    if (!grid || grid.getAttribute('data-ts-infinite') === 'on') return;

    if (current) current.stop();
    var list = new List(container);
    if (!list.usable()) return;

    current = list;
    list.setup();

    var state = readState();
    // 1ページ目の商品から戻った場合も復元する（標準の復元を止めているため、
    // ここで戻さないと一覧の先頭に戻ってしまう）
    if (state && state.url === baseUrl() && cameBack()) {
      list.restore(state);
    } else {
      clearState();
    }
  }

  function boot() {
    var container = document.querySelector(CONTAINER);
    if (!container) return;
    start(container);

    // 絞り込みや並べ替えを変えると Dawn が一覧を丸ごと差し替える。
    // 差し替わったら仕掛け直す。
    if ('MutationObserver' in window) {
      new MutationObserver(function () { start(container); })
        .observe(container, { childList: true });
    }
  }

  // ブラウザが一覧を丸ごと保存しておいて戻した場合（bfcache）。
  // スクリプトは走り直さず、読み込み済みのページもそのまま残っている。
  // Chrome はスクロール位置も戻すが、Safari（WebKit）は scrollRestoration が
  // manual だと位置を戻さず先頭に出す。ここで見ていた商品へ戻す。
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !current) return;
    var state = readState();
    if (!state || state.url !== baseUrl()) return;
    clearState();
    // 復元直後はまだ描画が整っていないことがあるので、次の描画で動かす
    requestAnimationFrame(function () { current.scrollTo(state); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
